<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">直播电商解决方案</div>
        <div class="line" />
        <div class="desc">
          直播电商服务，全渠道引流获客，电商+直播的全新互动方式，助力门店公域
          流量私域化；全场景的直播解决方案，助力门店实现流量高效变现。
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="solution">
      <div class="sk-block-title">
        <div class="title">一站式私域电商直播解决方案</div>
        <div class="sub-title">全渠道引流，品牌推广，直播互动营销，加速交易转化，打造线上线下一体化电商直播闭环</div>
      </div>
      <div class="content">
        <img src="@/assets/images/liveBroadcast/liveBroadcast_solution.png" alt="">
      </div>
    </div>
    <div class="share">
      <div class="left">
        <div class="wrap">
          <img src="@/assets/images/liveBroadcast/liveBroadcast_share1.png" alt="">
          <div>
            <span class="title">直播好货预告</span><br>
            <span class="sub-title">提前预热 提前锁客</span>
          </div>
        </div>
        <div class="wrap">
          <img src="@/assets/images/liveBroadcast/liveBroadcast_share2.png" alt="">
          <div>
            <span class="title">营销海报分享</span><br>
            <span class="sub-title">多渠道传播曝光直播信息</span>
          </div>
        </div>
        <div class="wrap">
          <img src="@/assets/images/liveBroadcast/liveBroadcast_share3.png" alt="">
          <div>
            <span class="title">微信小程序邀约</span><br>
            <span class="sub-title">触达微信好友 朋友圈</span>
          </div>
        </div>
      </div>
      <div class="right">
        <span class="title">直播预告分享 蓄水前置流量</span>
        <span class="desc">通过直播预热精准锁客，促进销售转化</span>
      </div>
    </div>
    <div class="show">
      <div class="share">
        <div class="right">
          <span class="title">轻松卖货 全方位展示商品</span>
          <span class="desc">直播中通过管理商品方便用户快速成交供应链能力灵活叠加，丰富直播商品库</span>
        </div>
        <div class="left">
          <div class="wrap">
            <img src="@/assets/images/liveBroadcast/liveBroadcast_show1.png" alt="">
            <div>
              <span class="title">讲解中商品 首页主推</span><br>
              <span class="sub-title">商品排序、推荐展示商品</span>
            </div>
          </div>
          <div class="wrap">
            <img src="@/assets/images/liveBroadcast/liveBroadcast_show2.png" alt="">
            <div>
              <span class="title">手动推荐展示热销商品</span><br>
              <span class="sub-title">商品排序、推荐展示商品</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sale">
      <div class="left">
        <img src="@/assets/images/liveBroadcast/liveBroadcast_sale.png" alt="">
        <div>
          <span class="title">花样玩法 根本停不下来</span><br>
          <span class="sub-title">直播中串联多种营销活动</span>
        </div>
      </div>
      <div class="right">
        <span class="title">多种营销玩法 提升粉丝参与感、提高销售转化</span>
        <span class="desc">红包（口令红包）、拉新、抽奖、点赞、秒杀等</span>
      </div>
    </div>
    <div class="scene">
      <div class="sale">
        <div class="right">
          <span class="title">为远程服务场景赋能</span>
          <span class="desc">直播作为基础服务平台，为更多远程场景提供便利服务</span>
        </div>
        <div class="left">
          <img src="@/assets/images/liveBroadcast/liveBroadcast_scene.png" alt="">
        </div>
      </div>
    </div>
    <div class="service">
      <div class="left">
        <img src="@/assets/images/liveBroadcast/liveBroadcast_service.png" alt="">
      </div>
      <div class="right">
        <span class="title">多渠道代播、直播代运营服务</span>
        <span class="desc">抖音、快手等多渠道代播、直播代运营服务，解决不懂直播运营，不会播，没人播的困扰</span>
      </div>
    </div>
    <div class="matrix">
      <div class="sk-block-title">
        <div class="title">汇好看直播产品矩阵</div>
      </div>
      <div class="content" />
    </div>
    <div class="advantage">
      <div class="sk-block-title">
        <div class="title">汇好看直播平台的优势</div>
      </div>
      <div class="content">
        <img src="@/assets/images/liveBroadcast/liveBroadcast_advantage.png" alt="">
      </div>
    </div>
    <div class="enable">
      <div class="sk-block-title">
        <div class="title">直播赋能，提升转化效果</div>
      </div>
      <div class="content">
        <img src="@/assets/images/liveBroadcast/liveBroadcast_enable.png" alt="">
      </div>
    </div>
    <CarouselItem title="直播电商" />
    <ConsultForm info-sources="直播电商" />
    <TryModal v-if="visible" :visible="visible" info-sources="直播电商" @cancel="modalClose" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.LiveBroadcast,
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {

  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
.content-center {
  .banner {
    background: url("~@/assets/images/liveBroadcast/liveBroadcast_banner.png") no-repeat center;
    background-size: 100% 100%;
    min-width: 1200px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 53px 0;
      text-align: left;
      .banner-title {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 55px;
      }
      .line {
        width: 100px;
        height: 6px;
        background: #28DAFB;
        margin: 16px 0 31px;
      }
      .desc {
        width: 675px;
        height: 101px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
      }
      .btn-wrap {
        .btn {
          width: 200px;
          height: 58px;
          line-height: 58px;
          border-radius: 6px;
          border: 1px solid #FFFFFF;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
        }
      }
    }
  }
  .solution {
    background: #fafafa;
    padding-bottom: 50px;
    .content {
      width: 1219px;
      margin: 49px auto 0;
    }
  }

  .share {
      display: flex;
      justify-content: space-between;
      width: 1207px;
      background: #fff;
      margin: 0 auto;
      padding: 37px 0 39px;
      .left {
        display: flex;
        .wrap {
          width: 276px;
          // height: 480px;
          justify-content: center;
          .title {
            font-size: 18px;
            font-weight: 500;
            color: #595961;
            line-height: 36px;
          }
          .sub-title {
            font-size: 16px;
            font-weight: 400;
            color: #595961;
            line-height: 36px;
          }
        }
      }
    }

    .right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        .title {
          font-size: 24px;
          font-weight: 600;
          color: #6862F6;
          line-height: 33px;
          text-align: left;
        }
        .desc {
          font-size: 18px;
          font-weight: 400;
          color: #595961;
          line-height: 36px;
          text-align: left;
          max-width: 494px;
        }
      }
      .show {
        background: #fafafa;
        .share {
          background: #fafafa;
        }
      }
      .sale, .service {
        display: flex;
        justify-content: space-between;
        width: 1123px;
        margin: 0 auto;
        padding: 45px 0 43px;
        background: #fff;
        .left {
          .title {
            font-size: 18px;
            font-weight: 500;
            color: #595961;
            line-height: 36px;
          }
          .sub-title {
            font-size: 16px;
            font-weight: 400;
            color: #595961;
            line-height: 36px;
          }
        }
      }

      .scene {
        background: #fafafa;
        .sale {
          background: #fafafa;
        }
      }

      .matrix {
        min-width: 1200px;
        height: 660px;
        margin: 0 auto;
        background: linear-gradient(182deg, #9531F2 0%, #382370 100%);
        // opacity: 0.85;
        padding: 0 0 52px;
        .title {
          color: #fff;
        }
        .content {
          width: 1107px;
          height: 461px;
          margin: 33px auto 0;
          background: url("~@/assets/images/liveBroadcast/liveBroadcast_matrix-bg.png") no-repeat;
        }
      }

      .advantage {
        background: #fafafa;
        padding-bottom: 41px;
        .content {
          img {
            width: 1025px;
            height: 565px;
            margin: 49px auto 0;
          }
        }
      }

      .enable {
        padding-bottom: 48px;
        .content {
          img {
            display: block;
            width: 1084px;
            height: 467px;
            margin: 50px auto 0;
          }
        }
      }
    }
</style>
